<p-panel header="Spatial Subsetting" [toggleable]="true">
  <ng-template pTemplate="icons">
    <label class="p-panel-header-icon"
           pTooltip="Restrict the input and reference data to a lat/lon bounding box (specified with lower left and upper right corner coordinates). You can also select the bounding box on the map above."
           tooltipPosition="bottom">
      <span class="pi pi-question-circle"></span>
    </label>
  </ng-template>

  <div class="grid pt-5 align-items-center">

    <!-- Left -->
    <div class="col-12 lg:col-5">
      <div class="grid align-items-center">
        <div class="col-4 text-right">
          <strong>Lower left:</strong>
        </div>
        <div class="col-4">
          <p-floatLabel>
            <p-inputNumber 
                class="w-full"
                inputStyleClass="w-full"
                inputId="minLatInputId" id="minLatInput" 
                [minFractionDigits]="1" [maxFractionDigits]="3"
                [ngModel]="subsetModel.minLat$|async"
                [min]="(subsetModel.minLatLimit$|async) ? (subsetModel.minLatLimit$|async) : -90"
                [max] ="checkValIfLimited(subsetModel.maxLat$|async, true)"
                (ngModelChange)="subsetModel.minLat$.next($event)">
            </p-inputNumber>
            <label for="minLatInputId">Min. Lat</label>
          </p-floatLabel>
        </div>
        <div class="col-4">
          <p-floatLabel>
            <p-inputNumber 
                class="w-full"
                inputStyleClass="w-full"
                id="minLonInput" 
                inputId="minLonInputId" 
                [minFractionDigits]="1" [maxFractionDigits]="3"
                [ngModel]="subsetModel.minLon$|async"
                [min]="(subsetModel.minLonLimit$|async) ? (subsetModel.minLonLimit$|async) : -180"
                [max]="checkValIfLimited(subsetModel.maxLon$|async, true)"
                (ngModelChange)="subsetModel.minLon$.next($event)">
              </p-inputNumber>
              <label for="minLonInputId">Min. Lon</label>
            </p-floatLabel>
        </div>
      </div>
    </div>

    <!-- Middle buttons -->
    <div class="col-12 lg:col-2 flex align-items-center justify-content-center">
        <button pButton
                title="clear-coordinates-button"
                type="button"
                icon="pi pi-trash"
                pTooltip="Clear coordinates"
                class="clearCoordinates p-button-danger"
                (click)="clearCoordinatesOrSetDefault()">
        </button>
    </div>

    <!--    Right  -->
    <div class="col-12 lg:col-5">
      <div class="grid align-items-center">
        <div class="col-4 text-right"> 
          <strong>Upper right:</strong>
        </div>

        <div class="col-4">
          <p-floatLabel>
            <p-inputNumber 
                  class="w-full"
                  inputStyleClass="w-full"
                  inputId="maxLatInputId" id="maxLatInput" 
                  [minFractionDigits]="1" [maxFractionDigits]="3"
                  [ngModel]="(subsetModel.maxLat$|async)"
                  [min]="checkValIfLimited(subsetModel.minLat$|async, true)"
                  [max]="(subsetModel.maxLatLimit$|async) ? (subsetModel.maxLatLimit$|async) : 90"
                  (ngModelChange)="subsetModel.maxLat$.next($event)">
            </p-inputNumber>
            <label for="maxLatInputId">Max. Lat</label>
          </p-floatLabel>
        </div>

        <div class="col-4">
            <p-floatLabel>
              <p-inputNumber 
                  class="w-full"
                  inputStyleClass="w-full"
                  inputId="maxLonInputId" id="maxLonInput" 
                  [minFractionDigits]="1" [maxFractionDigits]="3"
                  [ngModel]="subsetModel.maxLon$|async"
                  [min]="checkValIfLimited(subsetModel.minLon$|async, true)"
                  [max]="(subsetModel.maxLonLimit$|async) ? (subsetModel.maxLonLimit$|async) : 180"
                  (ngModelChange)="subsetModel.maxLon$.next($event)">
              </p-inputNumber>
              <label for="maxLonInputId">Max. Lon</label>
            </p-floatLabel>  
        </div>

      </div>
    </div>
  </div>
</p-panel>
